<template>
  <div id="service-parts-grid-tiles" class="sokal-modern-styles sokal-my-4">
    <div class="sokal-container sokal-py-1">
      <div class="row row-no-gutters heading-row">
        <p>Service & Parts</p>
        <h2 class="sokal-mt-0">We've got you covered</h2>
      </div>
      <div class="sokal-grid">
        <div class="sg-card main-card">
          <div class="sokal-flex sokal-items-center sokal-gap">
            <div class="bg-img visible-lg"></div>
            <div class="sokal-flex sokal-flex-col main-card-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                <path d="M10 40H40V45H10V40ZM5 27.5H30V32.5H5V27.5Z" fill="white"/>
                <path d="M74.7975 41.515L67.2975 24.015C67.1047 23.5654 66.7843 23.1822 66.376 22.9129C65.9676 22.6436 65.4892 22.5001 65 22.5H57.5V17.5C57.5 16.837 57.2366 16.2011 56.7678 15.7322C56.2989 15.2634 55.663 15 55 15H15V20H52.5V51.39C51.3615 52.0523 50.3651 52.9331 49.568 53.9816C48.7708 55.0302 48.1887 56.2258 47.855 57.5H32.145C31.5365 55.1434 30.0894 53.0895 28.075 51.7235C26.0605 50.3575 23.617 49.773 21.2025 50.0797C18.7879 50.3864 16.5681 51.5632 14.9592 53.3894C13.3502 55.2157 12.4625 57.5661 12.4625 60C12.4625 62.4339 13.3502 64.7843 14.9592 66.6106C16.5681 68.4368 18.7879 69.6136 21.2025 69.9203C23.617 70.227 26.0605 69.6425 28.075 68.2765C30.0894 66.9105 31.5365 64.8566 32.145 62.5H47.855C48.3988 64.6456 49.6426 66.5486 51.3894 67.9079C53.1363 69.2673 55.2865 70.0053 57.5 70.0053C59.7134 70.0053 61.8637 69.2673 63.6105 67.9079C65.3574 66.5486 66.6011 64.6456 67.145 62.5H72.5C73.163 62.5 73.7989 62.2366 74.2678 61.7678C74.7366 61.2989 75 60.663 75 60V42.5C74.9999 42.1613 74.931 41.8262 74.7975 41.515ZM22.5 65C21.5111 65 20.5444 64.7068 19.7221 64.1573C18.8999 63.6079 18.259 62.827 17.8806 61.9134C17.5021 60.9998 17.4031 59.9945 17.5961 59.0245C17.789 58.0546 18.2652 57.1637 18.9644 56.4645C19.6637 55.7652 20.5546 55.289 21.5245 55.0961C22.4944 54.9031 23.4998 55.0022 24.4134 55.3806C25.327 55.759 26.1079 56.3999 26.6573 57.2221C27.2067 58.0444 27.5 59.0111 27.5 60C27.5 61.3261 26.9732 62.5979 26.0355 63.5355C25.0978 64.4732 23.8261 65 22.5 65ZM57.5 27.5H63.35L68.71 40H57.5V27.5ZM57.5 65C56.5111 65 55.5444 64.7068 54.7221 64.1573C53.8999 63.6079 53.259 62.827 52.8806 61.9134C52.5021 60.9998 52.4031 59.9945 52.5961 59.0245C52.789 58.0546 53.2652 57.1637 53.9644 56.4645C54.6637 55.7652 55.5546 55.289 56.5245 55.0961C57.4944 54.9031 58.4998 55.0022 59.4134 55.3806C60.327 55.759 61.1079 56.3999 61.6573 57.2221C62.2067 58.0444 62.5 59.0111 62.5 60C62.5 61.3261 61.9732 62.5979 61.0355 63.5355C60.0978 64.4732 58.8261 65 57.5 65ZM70 57.5H67.145C66.5943 55.3586 65.3486 53.4604 63.6031 52.1031C61.8576 50.7459 59.7111 50.0061 57.5 50V45H70V57.5Z" fill="white"/>
              </svg>
              <h2 class="main-card-title">Schedule Pickup & Delivery</h2>
              <p class="main-card-description sokal-my-2 sokal-mt-0">We pick up and return your vehicle for service, making life that much easier.</p>
              <a class="sokal-btn sokal-btn-secondary has-border-radius" href="#">
                <div class="sokal-flex sokal-flex-row sokal-items-center sokal-justify-start">
                  <span class="sokal-btn-copy">Schedule Today</span>
                  <div class="sokal-btn-icon-slot" style="height: 1.6em;"></div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="sg-card sub-card sub-card-1 sokal-flex sokal-flex-col">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
            <path d="M18.6667 26.6669H26.6667V18.6669L17.3334 9.3336C20.319 7.90766 23.6733 7.44241 26.9344 8.00192C30.1955 8.56143 33.2029 10.1182 35.5425 12.4578C37.8821 14.7974 39.4388 17.8048 39.9984 21.0659C40.5579 24.3269 40.0926 27.6812 38.6667 30.6669L54.6667 46.6669C55.7275 47.7278 56.3235 49.1666 56.3235 50.6669C56.3235 52.1672 55.7275 53.6061 54.6667 54.6669C53.6058 55.7278 52.167 56.3238 50.6667 56.3238C49.1664 56.3238 47.7275 55.7278 46.6667 54.6669L30.6667 38.6669C27.681 40.0929 24.3267 40.5581 21.0656 39.9986C17.8046 39.4391 14.7972 37.8823 12.4575 35.5427C10.1179 33.2031 8.56119 30.1957 8.00168 26.9347C7.44217 23.6736 7.90741 20.3193 9.33335 17.3336L18.6667 26.6669Z" stroke="#066FEF" stroke-width="5.33333" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <h3 class="sub-card-title sokal-my-1">Schedule Service</h3>
          <p class="sub-card-description">Certified Ford service offering the best quality work for your vehicle.</p>
          <a class="sokal-link sokal-link-secondary" href="#">
            <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-start">
              <span class="sokal-link-copy">Schedule Today</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </a>
        </div>
        <div class="sg-card sub-card sub-card-2 sokal-flex sokal-flex-col">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
            <path d="M40 13.3335V18.6668M40 29.3335V34.6668M40 45.3335V50.6668M13.3333 13.3335H50.6667C52.0812 13.3335 53.4377 13.8954 54.4379 14.8956C55.4381 15.8958 56 17.2523 56 18.6668V26.6668C54.5855 26.6668 53.229 27.2287 52.2288 28.2289C51.2286 29.2291 50.6667 30.5857 50.6667 32.0002C50.6667 33.4146 51.2286 34.7712 52.2288 35.7714C53.229 36.7716 54.5855 37.3335 56 37.3335V45.3335C56 46.748 55.4381 48.1045 54.4379 49.1047C53.4377 50.1049 52.0812 50.6668 50.6667 50.6668H13.3333C11.9188 50.6668 10.5623 50.1049 9.5621 49.1047C8.5619 48.1045 8 46.748 8 45.3335V37.3335C9.41449 37.3335 10.771 36.7716 11.7712 35.7714C12.7714 34.7712 13.3333 33.4146 13.3333 32.0002C13.3333 30.5857 12.7714 29.2291 11.7712 28.2289C10.771 27.2287 9.41449 26.6668 8 26.6668V18.6668C8 17.2523 8.5619 15.8958 9.5621 14.8956C10.5623 13.8954 11.9188 13.3335 13.3333 13.3335Z" stroke="#066FEF" stroke-width="5.33" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <h3 class="sub-card-title sokal-my-1">Service & Parts Coupons</h3>
          <p class="sub-card-description">Save on your next maintenance visit or parts purchase, making your vehicle care more affordable and convenient.</p>
          <a class="sokal-link sokal-link-secondary" href="#">
            <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-start">
              <span class="sokal-link-copy">Explore Coupons</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </a>
        </div>
        <div class="sg-card sub-card sub-card-3 sokal-flex sokal-flex-col">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
            <path d="M53.3333 20L32 8L10.6666 20M53.3333 20V44L32 56M53.3333 20L32 32M32 56L10.6666 44V20M32 56V32M10.6666 20L32 32M42.6666 14L21.3333 26" stroke="#066FEF" stroke-width="5.33" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <h3 class="sub-card-title sokal-my-1">Order Parts</h3>
          <p class="sub-card-description">We offer the largest parts inventory in the area guaranteed.</p>
          <a class="sokal-link sokal-link-secondary" href="#">
            <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-start">
              <span class="sokal-link-copy">Start ordering</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

  export default {

  }
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/sokal-utility-classes.scss';
  @import '@/assets/styles/sokal-modern-styles.scss';
  @import '@/assets/styles/modern-utility-classes.scss';
  @import '@/assets/styles/sokal_utility_classes_responsive.scss';
</style>

<style scoped>
  @media (max-width: 1199px) {
    .visible-lg {
      display: none !important
    }
  }

  #service-parts-grid-tiles .heading-row p {
    color: var(--secondary-color);
    font-size: 1rem;
  }

  #service-parts-grid-tiles .heading-row h2 {
    color: var(--primary-dark);
    font-size: 3rem;
  }

  #service-parts-grid-tiles .sokal-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  #service-parts-grid-tiles .sg-card {
    padding: 25px;
    border-radius: 20px;
    font-size: 1.2rem;
  }

  #service-parts-grid-tiles .main-card {
    grid-column: 1 / 4;
    background: var(--secondary-color, #066FEF);
    color: #ffffff;
  }
  #service-parts-grid-tiles .main-card .bg-img {
    background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/781/019/original/delivery.png?1764004057);
    background-repeat: no-repeat;
    background-size: cover;
    background-position-y: top;
    border-radius: 20px;
    width: 50%;
    height: 25em;
  }
    
  #service-parts-grid-tiles .main-card .main-card-title,
  #service-parts-grid-tiles .sub-card .sub-card-title {
    font-size: 2rem;
  }

  #service-parts-grid-tiles .main-card .main-card-description,
  #service-parts-grid-tiles .sub-card .sub-card-description {
    font-size: 1.5rem;
  }

  #service-parts-grid-tiles .main-card .sokal-btn.sokal-btn-secondary {
    width: fit-content;
    font-size: 1.4rem;
    font-weight: 700;
    border-radius: var(--brand-br);
    border-color: #ffffff;
  }

  #service-parts-grid-tiles .sub-card {
    background-color: #F0F0F0;
    color: var(--primary-dark);
  }

  #service-parts-grid-tiles .sub-card .sokal-link.sokal-link-secondary {
    font-size: 1.5rem;
    font-weight: 600;
    margin-top: auto;
  }

  @media (min-width: 1200px) {
    #service-parts-grid-tiles .main-card-content {
      margin-left: 3em;
    }

    #service-parts-grid-tiles .main-card .main-card-title {
      font-size: 3rem;
    }

    #service-parts-grid-tiles .sub-card {
      height: 25em;
    }
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    #service-parts-grid-tiles .sokal-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    #service-parts-grid-tiles .main-card,
    #service-parts-grid-tiles .sub-card-2 {
      grid-column: 1 / 2;
    }
    #service-parts-grid-tiles .sub-card-1,
    #service-parts-grid-tiles .sub-card-3 {
      grid-column: 2 / 2;
    }
  }

  @media (max-width: 991px) {
    #service-parts-grid-tiles .sokal-grid .sokal-card {
      min-height: 15em;
      padding: 1.5em 1em;
    }
    #service-parts-grid-tiles .sokal-grid .sokal-card p.h2 {
      font-size: 2em;
    }
  }

  @media (max-width: 767px) {
    #service-parts-grid-tiles .sokal-grid {
      grid-template-columns: 1fr;
    }

    #service-parts-grid-tiles .main-card,
    #service-parts-grid-tiles .sub-card {
      grid-column: 1 / 4;
    }
  }

  @media (max-width: 575px) {
    #service-parts-grid-tiles .sokal-grid .sokal-card {
      min-height: 12em;
    }
  }
</style>